<template>
    <v-dialog v-model="showLogin" fullscreen persistent>
        <v-card height="100%" class="d-flex align-center" style="overflow-x: hidden">
            <v-row>
                <v-col lg="4" offset-lg="4" xs="12">
                    <v-card-title class="headline" primary-title>
                        Register
                    </v-card-title>
                    <v-card-text v-if="!registerSuccess">
                        <v-layout>
                            <v-flex xs12>
                                <v-alert v-if="error" outlined color="error" icon="mdi-alert-circle" :value="true">
                                    {{errorMessage}}
                                </v-alert>
                                <v-form v-model="valid" action="login">
                                    <v-text-field outlined
                                            label="E-mail"
                                            v-model="email"
                                            :rules="[rules.required, rules.email]"
                                    ></v-text-field>
                                    <v-text-field outlined
                                            label="Enter your password"
                                            :hint="getHint('password1')"
                                            v-model="password1"
                                            min="8"
                                            :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                                                  @click:append="() => (passwordVisible = !passwordVisible)"
                                            :type="passwordVisible ? 'password' : 'text'"
                                            counter
                                    ></v-text-field>
                                    <v-text-field outlined
                                            label="Re-enter your password"
                                            :hint="password2 === password1 ? '' : 'Passwords must match'"
                                            v-model="password2"
                                            min="6"
                                            :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="() => (passwordVisible = !passwordVisible)"
                                            :type="passwordVisible ? 'password' : 'text'"
                                            counter
                                    ></v-text-field>
                                </v-form>
                            </v-flex>
                        </v-layout>
                        <v-btn depressed :disabled="!canSubmit" block color="primary" @click.stop="doSubmit">
                            <span>Submit</span>
                        </v-btn>
                    </v-card-text>
                    <v-card-text v-if="registerSuccess">
                        <v-alert outlined color="success" icon="mdi-check-circle" :value="true">
                            You were registered successfully.
                        </v-alert>
                        <v-btn depressed to="login" color="primary" dark block>Login</v-btn>
                    </v-card-text>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
  import gx from 'vue'

  export default {
    name: 'Register',

    mounted() {
      console.dir(this.$router);
      this.actionCode = this.$router.currentRoute.query.oobCode;
    },

    computed: {
      canSubmit() {
        if (this.rules.email(this.email) !== true) {
          return false;
        }

        if (this.password1 === "" || this.password2 === "")
          return false;

        if (this.password1 !== this.password2)
          return false;

        return true
      },
      isLongEnough() {
        return this.password1.length > 5
      },
      hasUpperAndLowerCase() {
        return this.password1.match(/[A-Z]/)
      },
      hasNumber() {
        return this.password1.match(/\d/)
      }
    },

    data() {
      return {
        registerSuccess: false,
        passwordVisible: true,
        actionCode: '',
        showLogin: true,
        error: false,
        email: '',
        password1: '',
        password2: '',
        rules: {
          required: (value) => !!value || 'Required.',
          email: (value) => {
            var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
        }
      }
    },

    methods: {
      getHint() {
        var retStr = "";

        if (!this.isLongEnough)
          retStr += "Min. 6 characters,";

        if (!this.hasNumber)
          retStr += "Includes a number,";

        if (!this.hasUpperAndLowerCase)
          retStr += "UPPER and lower case";

        return retStr
      },
      formatErrorMessage(msg) {
        return this.errorList[msg];
      },
      doSubmit() {

        this.error = false;
        this.errorMessage = '';
        this.$store.dispatch('REGISTER_USER', {
          email: this.email.toLowerCase(),
          password: this.password1
        }).then((res) => {
          console.dir(res)
          if (res.data.email) {
            this.$router.push({
              name: 'Login',
              params: {
                email: res.data.email
              }
            })
          }

          if (res.data.code) {
            this.error = true;
            this.errorMessage = res.data.message;
          }
        })
      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .valid {
        color: green;
    }

    .invalid {
        color: red;
    }
</style>
